import { IAmenityCountItem, SizedAmenityType, ISizedAmenityItem, AmenityCountType } from 'components/bulletin-form/components/amenity-with-counter/types';
import { PocType, PoiType, POC, DealType, Amenity } from 'utils/entities';

export function createListOfIdsForAboutSection<T extends { id: string }>(data: T[], idToExclude: string, limit = 10) {
  return data.map(({ id }) => id).filter(id => id !== idToExclude).slice(0, limit);
}

export enum OverviewDetails {
  Project = 'project',
  Agent = 'agent',
  Private = 'private',
  None = 'none',
}

export const getOverviewAgentType = (type: PoiType, poc: PocType): OverviewDetails => {
  if (type === 'project') return OverviewDetails.Project;
  if (poc === PocType.Private) return OverviewDetails.Private;
  if (poc === PocType.Agent) return OverviewDetails.Agent;
  return OverviewDetails.None;
};

const MIMUN_YASHIR_OFFICE_IDS_SET = new Set([ 're_office_k1qOUhOj0Uz', 're_office_bTCABruB8ky' ]);

export const isAgentFromMimunYashir = (poc: POC, dealType: DealType): boolean => {
  const isSale = dealType === DealType.Buy;
  if (poc && poc.type === PocType.Agent && poc.officeId && isSale) {
    return MIMUN_YASHIR_OFFICE_IDS_SET.has(poc.officeId);
  }
  return false;
};

export const WHATSAPP_BULLETIN_ID_TO_PHONE = new Map([
  [ 'iPJOQDC5JZ4', '+972547347589' ],
  [ 'cvaeEFKTGMW', '+972547347589' ],
  [ 'd0q4TLYNHnS', '+972547347589' ],
  [ 'h2Vu2HjY8oj', '+972547347589' ],
  [ 'bHrcVOmlNS0', '+972547347589' ],
  [ 'c8icLqx6qUo', '+972547347589' ],
  [ 'ktB47i3EN0f', '+972547347589' ],
  [ 'gQKzFrIPj2h', '+972547347589' ],
  [ 'i8eixkrdIXQ', '+972547347589' ],
  [ 'i31qljsVLFj', '+972547347589' ],
  [ 'ROhg88O65I', '+972547347589' ],
  [ 'khz77fZUJEr', '+972547347589' ],
  [ 'hlJHeUE3zV5', '+972547347589' ],
  [ 'jIO9LqhIn6l', '+972547347589' ],
  [ 'bt06ISQBYqs', '+972547347589' ],
  [ 'i3d4IbdJikW', '+972547347589' ],
  [ 'kn82wEVG2RY', '+972547347589' ],
  [ 'hF9gxpVdrA1', '+972547347589' ],
  [ 'cHoCIkQefEY', '+972547347589' ],
  [ 'iv1pv6ZxV9O', '+972547347589' ],
  [ 'jhv8OasPrem', '+972547347589' ],
  [ 'hb5ac4vepSt', '+972547347589' ],
  [ 'eg5kxqqYFSP', '+972547347589' ],
  [ 'djyvLVEYSVT', '+972547347589' ],
  [ 'gU2Y1Vbygf0', '+972542093925' ],
  [ 'hDvZMM6uQdS', '+972542093925' ],
  [ 'j0fhPGahjRJ', '+972542093925' ],
  [ 'jQkLsyF683W', '+972542093925' ],
  [ 'kvbb8OlivZb', '+972542093925' ],
  [ 'cNWjrrf2Mzq', '+972542093925' ],
  [ 'cQnbKrl8jSK', '+972542093925' ],
  [ 'fC34aiaUyqg', '+972542093925' ],
  [ 'cVfp2PgJPFM', '+972542093925' ],
  [ 'fZx7Dkx8IXW', '+972542093925' ],
  [ 'mH0APyunMh', '+972542093925' ],
  [ 'iCEo4edkrRT', '+972542093925' ],
  [ 'fwXQ5gGQgqb', '+972542093925' ],
  [ 'iQCDqQss0Xn', '+972542093925' ],
  [ 'hVatG1nq2NN', '+972542093925' ],
  [ 'kxC1jcJXGsI', '+972542093925' ],
  [ 'cVuqOjPIx5H', '+972542093925' ],
  [ 'jRbwZp6GgXD', '+972542093925' ],
  [ 'e7yXW07ulo1', '+972542093925' ],
  [ 'hLDtuWEWaCX', '+972542093925' ],
  [ 'kJniwJmkjHs', '+972542093925' ],
  [ 'kPiXNFqnLiA', '+972542093925' ],
  [ 'hEDmKpwtejJ', '+972542093925' ],
  [ 'ctzjFqjyjZe', '+972542093925' ],
  [ 'k4FdggLGaYO', '+972542093925' ],
  [ 'hELkoKHMyDu', '+972542093925' ],
  [ 'ckzFDlRq1dt', '+972542093925' ],
  [ 'gUTsak2y1ni', '+972542093925' ],
  [ 'gBm0pAxLRLk', '+972542093925' ],
  [ 'frgJ2ElPoEE', '+972542093925' ],
  [ 'bHw69cjOq8A', '+972542093925' ],
  [ 'gA3cfTDU6Nw', '+972544457872' ],
  [ 'iK2cYTfAcmg', '+972544457872' ],
  [ 'dTJBRuJL4NP', '+972544457872' ],
  [ 'dU2dVgheic6', '+972524857006' ],
  [ 'iHOxAZYqPNn', '+972524857006' ],
  [ 'STshfREu4O', '+972524857006' ],
  [ 'dpocMP2y0kW', '+972524857006' ],
  [ 'fKUeQOnS7cP', '+972524857006' ],
  [ 'etQTzECQXBL', '+972524857006' ],
  [ 'gsAibGByUni', '+972524857006' ],
  [ 'bXKLL8LFeoj', '+972509204786' ],
  [ 'fpefdv8ksTH', '+972509204786' ],
  [ 'fYR23dsU745', '+972509204786' ],
  [ 'caRyPJyiyiz', '+972509204786' ],
  [ 'cQ6k1RhDabR', '+972509204786' ],
  [ 'jSyt9emTwwz', '+972509204786' ],
  [ 'dIPr67UDhQX', '+972509204786' ],
  [ 'h72FhOQkG4b', '+972509204786' ],
  [ 'hrPBo1jeGHw', '+972509204786' ],
  [ 'iVaCuOv6HAD', '+972509204786' ],
  [ 'jAljqdDh9Ol', '+972509204786' ],
  [ 'e9eLLwKm43v', '+972509204786' ],
  [ 'i8nL3FtQ87y', '+972509204786' ],
  [ 'k7X1p6XlIcj', '+972509204786' ],
  [ 'cufA26HAP2P', '+972509204786' ],
  [ 'ktE2cEaW5yF', '+972509204786' ],
  [ 'puyUwbqIu2', '+972509204786' ],
  [ 'gJzvHM3B9Ni', '+972509204786' ],
  [ 'fWtz9m1DJaW', '+972509204786' ],
  [ 'bYamgNJqzv3', '+972509204786' ],
  [ 'eIQYL9HneKw', '+972509204786' ],
  [ 'Ct0JZqNRdJ', '+972525591208' ],
  [ 'eJBr2P44vLx', '+972525591208' ],
  [ 'cJ90av15Cwb', '+972525591208' ],
  [ 'iVAiVnLL2S0', '+972525591208' ],
  [ 'cXv1fS3Z98L', '+972525591208' ],
  [ 'kLvjOs104FW', '+972525591208' ],
  [ 'kaAA9Jyey1v', '+972525591208' ],
  [ 'htysLK3Cd6Y', '+972525591208' ],
  [ 'b6LZpxGNG8u', '+972525591208' ],
  [ 'hZfNvqs4C7z', '+972525591208' ],
  [ 'g6MGRBZP4pI', '+972525591208' ],
  [ 'knEobdTrYx5', '+972525591208' ],
  [ 'gy3V1UqMKzi', '+972525209108' ],
  [ 'iw870gxKUHf', '+972525209108' ],
  [ 'haeAVeSlP9V', '+972525209108' ],
  [ 'blhc8O7wD6H', '+972525209108' ],
  [ 'kPOQ8LcCXkp', '+972525209108' ],
  [ 'gZvDE2ZukNt', '+972525209108' ],
  [ 'fTaZCcsRHpE', '+972525209108' ],
  [ 'kkuDizw3tcL', '+972525209108' ],
  [ 'jOsFUDfdyuf', '+972525209108' ],
  [ 'gtZhqbEwRwD', '+972525209108' ],
  [ 'cngoxNoDTyb', '+972525209108' ],
  [ 'kpVQ6I7uSWe', '+972525209108' ],
  [ 'fAEoUkDdbNo', '+972525209108' ],
  [ 'juWUDQnlyag', '+972525209108' ],
  [ 'c5m62DugKom', '+972525209108' ],
  [ 'imdheo5z8hy', '+972525209108' ],
  [ 'jLsy13g0qiH', '+972525209108' ],
  [ 'd06wYld6dx8', '+972525209108' ],
  [ 'fQUFKIEyO3f', '+972525209108' ],
  [ 'is3NL1ugqbb', '+972549277468' ],
  [ 'ewrbdJNY4xQ', '+972549277468' ],
  [ 'LdgaP6Ej6H', '+972549277468' ],
  [ 'hu9EcnhJ3V', '+972549277468' ],
  [ 'h5AGn6222qL', '+972549277468' ],
  [ 'beQnEYjI0Rp', '+972549277468' ],
  [ 'kgEOkC6ZKXv', '+972549277468' ],
  [ 'jClXw2AoooB', '+972549277468' ],
  [ 'cndGELIxX0S', '+972549277468' ],
  [ 'fFVWlToE304', '+972549277468' ],
  [ 'e9r2Y95GudW', '+972549277468' ],
  [ 'dInRK8RGWDi', '+972549277468' ],
  [ 'Zkijxqg7zN', '+972549277468' ],
  [ 'e9Lf80zRa9F', '+972547854414' ],
  [ 'fgHiyfOnUnT', '+972547854414' ],
  [ 'f5dB7iQ2Q7p', '+972547854414' ],
  [ 'bzzLU59ETYn', '+972523200852' ],
  [ 'ezJ3TQkiwa', '+972523200852' ],
  [ 'ju4cVZAQSFp', '+972523200852' ],
  [ 'bpBTY7Rj5L2', '+972523200852' ],
  [ 'hcYOAs6xHL0', '+972523200852' ],
  [ 'dDar5JudU9G', '+972523200852' ],
  [ 'gH3lEkk3209', '+972507997856' ],
  [ 'd40gAcwxpU3', '+972507997856' ],
  [ 'hsLMCT1jJbz', '+972507997856' ],
  [ 'ji6PhlEgE4D', '+972507997856' ],
  [ 'dnnaZ4URdMk', '+972507997856' ],
  [ 'gNUlkUU0PCA', '+972525773168' ],
  [ 'ijLQLhMFYZR', '+972525773168' ],
  [ 'hExJly8AAxm', '+972525773168' ],
  [ 'fv7FNcs3ktp', '+972525773168' ],
  [ 'kXW9OA3uBLi', '+972525773168' ],
  [ 'crnqA4ZpCvu', '+972525773168' ],
  [ 'fMVBDUFvJlM', '+972525773168' ],
  [ 'hNEx6R332tA', '+972525773168' ],
  [ 'g6ac7x98NEu', '+972532844242' ],
  [ 'inXFtGxyw2n', '+972532844242' ],
  [ 'k0Zi9BLCmVi', '+972532844242' ],
  [ 'dqWawDyWkZv', '+972532844242' ],
  [ 'gfO4ecUQCzY', '+972532844242' ],
  [ 'cqIosqFDFVG', '+972532844242' ],
  [ 'cMZoM4QVfPh', '+972532844242' ],
  [ 'f5a30fl4zH7', '+972532844242' ],
  [ 'fQZ9TqCXsuC', '+972532844242' ],
  [ 'U8tDdSbP8q', '+972532844242' ],
  [ 'jhFAoMctYse', '+972532844242' ],
  [ 'fWdJU4vsC9u', '+972532844242' ],
  [ 'ga3SNXvj6r0', '+972532844242' ],
  [ 'hoUZVRmfBgF', '+972532844242' ],
  [ 'iuczviynO7a', '+972532844242' ],
  [ 'ej0wPtcNj04', '+972532844242' ],
  [ 'imZ7opVDJcT', '+972549735588' ],
  [ 'kbmipNwq3tx', '+972525199090' ],
  [ 'kFsOAXoa1RV', '+972525199090' ],
  [ 'gJFcoGge7cQ', '+972525199090' ],
  [ 'kp9PCQ5KeST', '+972525199090' ],
  [ 'iFo30KojPwp', '+972525199090' ],
  [ 'bR9WqoJUYQV', '+972525199090' ],
  [ 'dzukaSNt4z4', '+972525199090' ],
  [ 'izwUXWeRJzH', '+972525199090' ],
  [ 'keFAJrqvYk8', '+972525199090' ],
  [ 'c34woGFfmsS', '+972525199090' ],
  [ 'msVeFlI51u', '+972525199090' ],
  [ 'f5siybs4AkU', '+972525199090' ],
  [ 'espIMls18FE', '+972525199090' ],
  [ 'cNbsrQNZ5IZ', '+972525199090' ],
  [ 'jsEQ7fjYQHf', '+972546127612' ],
  [ 'cwV95UXgUZN', '+972546127612' ],
  [ 'kb4P92sswgE', '+972546127612' ],
  [ 'ijxYp2KSqgi', '+972546127612' ],
  [ 'fWyh1mctBKC', '+972546127612' ],
  [ 'jfdf5Pq6JQ7', '+972546127612' ],
  [ 'fMtTe7P9f7a', '+972546127612' ],
  [ 'go0qZnGfVVN', '+972546127612' ],
  [ 'h53y7M0USs2', '+972546127612' ],
  [ 'iTSkfUfgo3b', '+972546127612' ],
  [ 'jZoZaobkYwB', '+972546127612' ],
  [ 'fw90lk70iQ', '+972546127612' ],
  [ 'eq5j1FpcTXp', '+972546127612' ],
  [ 'j9ToHXtxfvL', '+972546127612' ],
  [ 'd1aJW3OObO5', '+972546127612' ],
  [ 'hiei2xi2S0l', '+972546127612' ],
  [ 'coh2GyEnpIn', '+972546127612' ],
  [ 'h1NoTl5EGvj', '+972546127612' ],
  [ 'hP2M3EAib0a', '+972546127612' ],
  [ 'iQgP2El8Azd', '+972522660679' ],
  [ 'dEo3ZiI1KZa', '+972522660679' ],
  [ 'dUdO3RVEKMZ', '+972522660679' ],
  [ 'fCL9GOeHHJK', '+972522660679' ],
  [ 'iyf4jW8250U', '+972522660679' ],
  [ 'bKDl3mPAb7s', '+972522660679' ],
  [ 'fQax0TAG5S4', '+972544520224' ],
  [ 'iPKdyIgE2au', '+972544520224' ],
  [ 'fnmo4RJCBLx', '+972544520224' ],
  [ 'hXMiwDDEhF', '+972544520224' ],
  [ 'dmIFpjTVbSc', '+972544520224' ],
  [ 'diICdOUp3qI', '+972544520224' ],
  [ 'bVB0mWQncCk', '+972544520224' ],
  [ 'dtxIAahSBxr', '+972544520224' ],
  [ 'iCwOazlosbb', '+972544520224' ],
  [ 'dkm0ZTVqE2F', '+972544520224' ],
  [ 'ieA6HhswNoG', '+972544520224' ],
  [ 'cHMYbPi48KM', '+972544520224' ],
  [ 'fNl6KLWZgwH', '+972544520224' ],
  [ 'hvpPfbC2AyS', '+972544520224' ],
  [ 'ewFZBYqsfit', '+972525150283' ],
  [ 'h3V3lyGjyrX', '+972525150283' ],
  [ 'ika0d3MRpbd', '+972525150283' ],
  [ 'bmatwrFBDQH', '+972507406850' ],
  [ 'jwQxxkVD1b0', '+972543502073' ],
  [ 'geQ0MYBUdSu', '+972543502073' ],
  [ 'dFeY6UYlV8f', '+972543502073' ],
  [ 'kGfwsvEHCjw', '+972543502073' ],
]);

export const shouldDisplayWhatsAppButton = (bulletinId: string) => {
  return WHATSAPP_BULLETIN_ID_TO_PHONE.has(bulletinId);
};

export const WHATSAPP_PROJECT_ID_TO_PHONE: Map<string, string> = new Map([]);

export const shouldDisplayWhatsAppButtonProject = (projectId: string) => {
  return WHATSAPP_PROJECT_ID_TO_PHONE.has(projectId);
};

export function getSizedAmenity(sizedAmenities: ISizedAmenityItem[], type: SizedAmenityType): number[] {
  const item = sizedAmenities.find(val => val.type === type);
  if (!item) return [];
  return item.sizes;
}

export function getAmenityCount(amenityCounts: IAmenityCountItem[], type: AmenityCountType): number | null {
  const item = amenityCounts.find(val => val.type === type);
  if (!item) return null;
  return item.count;
}

export function getAmenitiesForChecklist(amenities: Record<Amenity, boolean>, {
  balconyAreas,
  warehouseAreas,
  gardenAreas,
  parking,
}: {
  balconyAreas: number[];
  warehouseAreas: number[];
  gardenAreas: number[];
  parking: number;
}): Record<Amenity, boolean> {
  return {
    ...amenities,
    balcony: amenities.balcony || balconyAreas.length > 0,
    storage: amenities.storage || warehouseAreas.length > 0,
    garden: amenities.garden || gardenAreas.length > 0,
    parking: amenities.parking || parking > 0,
  };
}
